<template>
    <div class="col-span-6 sm:col-span-3">
        <label for="update" class="block text-sm font-medium text-gray-700">&nbsp;</label>
            <button @click.prevent="handleClick" dusk="D-saveManualAddress" class="mt-1 block rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm border bg-cyan hover:bg-cyan-700 text-black font-medium text-sm w-1/2 lg:w-1/3">
                Save
        </button>
    </div>
</template>

<script>
export default {
    name: "ManuallySaveAddress",
    props: {
        toggleAction: {
            type: Function,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLine1Filled: false,
            isTownFilled: false
        }
    },
    methods: {
        handleClick() {
            this.toggleAction(this.data);
        }
    },
}

</script>

<style scoped>
</style>
